import { igniteUserPromiseClient } from '~/services/ignite-client';

const USERS_PAGE_SIZE = BigInt(20000);

export const listUsers = async () =>
  await igniteUserPromiseClient.listUsers({
    pageSize: USERS_PAGE_SIZE,
  });
